module.exports = __webpack_public_path__ + "img/2.c4133bc9.jpg";